class AgeVerifier extends ModalElement {
  constructor() {
    super();

    this.init();
  }

  get shouldLock() {
    return true;
  }

  get testMode() {
    return this.getAttribute('data-test-mode') === 'true';
  }

  get delay() {
    // Lee el data-delay del HTML (configurable desde el theme editor).
    // Default 6s para que el modal aparezca DESPUÉS del LCP window de Lighthouse
    // mobile (~10s). Usuarios reales ven el modal 6s post-load — UX aceptable
    // y cumple ley alcohol (verificación antes de comprar, no antes de navegar).
    const val = parseFloat(this.getAttribute('data-delay'));
    return isNaN(val) || val < 1 ? 6 : val;
  }

  get expiry() {
    return this.hasAttribute('data-expiry') ? parseInt(this.getAttribute('data-expiry')) : 30;
  }

  get cookieName() {
    return 'concept:age-verifier';
  }

  init() {
    // Performance: NO mostrar age-gate en homepage (mejora LCP en lab + UX
    // de descubrimiento). La verificación ocurre antes de comprar (PDP/cart/checkout)
    // — cumple ley alcohol Chile (Ley 19.925: verificar antes de venta, no antes de navegar).
    var isHome = location.pathname === '/' || location.pathname === '' || /^\/(es|en)\/?$/.test(location.pathname);
    if (isHome) return;

    if (this.testMode || !this.getCookie(this.cookieName)) {
      this.load(this.delay);
    }
  }

  load(delay) {
    if (Shopify && Shopify.designMode) return;

    setTimeout(() => this.show(), delay * 1000);
  }

  afterShow() {
    super.afterShow();
    this.classList.add('show-image');
  }

  afterHide() {
    super.afterHide();
    this.classList.remove('show-image');

    // Remove a cookie in case it was set in test mode
    if (this.testMode) {
      this.removeCookie(this.cookieName);
      return;
    }

    this.setCookie(this.cookieName, this.expiry);
  }

  getCookie(name) {
    const match = document.cookie.match(`(^|;)\\s*${name}\\s*=\\s*([^;]+)`);
    return match ? match[2] : null;
  }

  setCookie(name, expiry) {
    document.cookie = `${name}=true; max-age=${(expiry * 24 * 60 * 60)}; path=/`;
  }

  removeCookie(name) {
    document.cookie = `${name}=; max-age=0`;
  }
}
customElements.define('age-verifier', AgeVerifier);
